/**
* ScoreEntry.js
* 
* Created on Oct 9, 2013, 3:39:10 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class ScoreEntry {
    constructor(scenarioID, causeID, category, partID, value) {
        this.scenarioID = scenarioID;
        this.causeID = causeID;
        this.scoreCategory = category;
        this.partID = partID;
        this.value = value;
    };
}